module.exports = __webpack_public_path__ + "media/images/badges/new-fuel-sources-100-2455c307d30fa2fde6b71d4af02c4322.svg";